import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconQuestionMarkCircle(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M8.625 11.25a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0M8 4.625c-1.312 0-2.375.953-2.375 2.125V7a.375.375 0 1 0 .75 0v-.25c0-.758.729-1.375 1.625-1.375s1.625.617 1.625 1.375S8.896 8.125 8 8.125a.375.375 0 0 0-.375.375V9a.375.375 0 0 0 .75 0v-.151c1.132-.162 2-1.041 2-2.099 0-1.172-1.062-2.125-2.375-2.125M14.375 8A6.375 6.375 0 1 1 8 1.625 6.38 6.38 0 0 1 14.375 8m-.75 0A5.625 5.625 0 1 0 8 13.625 5.63 5.63 0 0 0 13.625 8"
      />
    </SVGIcon>
  );
}
